import api from '@/api';
import { API_BASE_URL } from '..';
import {
  EnterprisePecaAiSearchProductRequest,
  EnterprisePecaAiSearchProductResponse,
} from './pecaAi.types';

const CONTROLLER = `${API_BASE_URL}/peca-ai`;

export default {
  async searchProduct(params?: EnterprisePecaAiSearchProductRequest) {
    const response = (await api.get(
      `${CONTROLLER}/search-product`,
      params,
    )) as unknown;
    return response as EnterprisePecaAiSearchProductResponse;
  },
};
